import React from 'react';

const emailConfirmed = () => (
  <svg
    width="160"
    height="127"
    viewBox="0 0 160 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_ddd557kdn003)">
      <rect x="24.2568" y="24.0234" width="111.219" height="77.0488" rx="10" fill="white" />
    </g>
    <path
      opacity="0.4"
      d="M135.644 94.1196C136.068 92.9718 87.4522 56.1444 87.4522 56.1444C81.3658 51.6384 78.1647 51.5675 72.1461 56.1444C72.1461 56.1444 23.6012 92.942 24.0098 94.0741L24 94.0824C24.005 94.0923 24.0131 94.0991 24.0199 94.1081C24.4315 95.2338 25.0303 96.2814 25.791 97.2064C26.1123 97.5972 26.4995 97.9246 26.8719 98.265L26.8538 98.279C26.8835 98.3054 26.923 98.3177 26.9526 98.3442C28.5309 99.7567 30.5213 100.672 32.7324 100.933C32.7671 100.937 32.7951 100.955 32.8297 100.959H32.9632C33.2994 100.991 33.619 101.072 33.9632 101.072H125.743C130.262 101.072 134.091 98.221 135.612 94.224C135.63 94.1943 135.658 94.1728 135.674 94.1422L135.644 94.1196Z"
      fill="#4CADBA"
    />
    <path
      opacity="0.6"
      d="M79.8664 51.9181L24.2568 93.7602V34.484C24.2568 28.7062 28.9245 24.0234 34.6836 24.0234H125.049C130.808 24.0234 135.476 28.7062 135.476 34.484V93.7602L79.8664 51.9181Z"
      fill="#B0DAE0"
    />
    <path
      d="M24.9053 30.8483L72.384 68.2611C78.3765 72.6975 81.5283 72.7675 87.4543 68.2611L134.858 30.9076C134.036 29.412 132.805 28.2304 131.397 27.2882L132.049 26.7756C130.457 25.3222 128.423 24.3801 126.165 24.1367L33.5712 24.14C31.3195 24.3801 29.282 25.3255 27.6939 26.7756L28.3411 27.2819C26.9493 28.2109 25.7294 29.3721 24.9053 30.8483Z"
      fill="#EDECE6"
    />
    <path
      d="M24.8896 30.9236C24.4727 32.054 72.3393 68.3137 72.3393 68.3137C78.3318 72.75 81.4836 72.8201 87.4096 68.3137C87.4096 68.3137 135.206 32.0833 134.804 30.9685L134.814 30.9604C134.809 30.9506 134.801 30.9442 134.794 30.9352C134.389 29.8268 133.799 28.7953 133.05 27.8846C132.734 27.4997 132.353 27.1775 131.986 26.8422L132.004 26.8284C131.975 26.8024 131.936 26.7901 131.907 26.7641C130.353 25.3735 128.393 24.4727 126.216 24.2156C126.182 24.2114 126.155 24.1937 126.121 24.1895H125.989C125.658 24.1578 125.343 24.0781 125.004 24.0781H34.639C30.1893 24.0781 26.4192 26.8856 24.9221 30.8208C24.9042 30.8501 24.8767 30.8713 24.8604 30.9013L24.8896 30.9236Z"
      fill="#E0F1F3"
    />
    <g filter="url(#filter1_ddd555nnvvcp8)">
      <path
        d="M151.614 95.6477C151.614 86.3693 144.092 78.8477 134.814 78.8477C125.535 78.8477 118.014 86.3693 118.014 95.6477V95.7564C118.014 105.035 125.535 112.556 134.814 112.556C144.092 112.556 151.614 105.035 151.614 95.7564V95.6477Z"
        fill="white"
      />
    </g>
    <path
      d="M134.814 81.3477C126.894 81.3477 120.414 87.8277 120.414 95.7477C120.414 103.668 126.894 110.148 134.814 110.148C142.734 110.148 149.214 103.668 149.214 95.7477C149.214 87.8277 142.734 81.3477 134.814 81.3477ZM134.814 107.268C128.464 107.268 123.294 102.098 123.294 95.7477C123.294 89.3973 128.464 84.2277 134.814 84.2277C141.164 84.2277 146.334 89.3973 146.334 95.7477C146.334 102.098 141.164 107.268 134.814 107.268ZM141.424 89.3829L131.934 98.8725L128.204 95.1573L126.174 97.1877L131.934 102.948L143.454 91.4277L141.424 89.3829Z"
      fill="#0A8EA0"
    />
    <defs>
      <filter
        id="filter0_ddd557kdn003"
        x="16.2568"
        y="20.0234"
        width="127.219"
        height="93.0488"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow" result="shape" />
      </filter>
      <filter
        id="filter1_ddd555nnvvcp8"
        x="110.014"
        y="74.8477"
        width="49.6"
        height="49.7087"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default emailConfirmed;
